










































































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import axios from 'axios';

let CSRF_TOKEN: string;
let CSRF_TOKEN_GROUP = document.cookie.match(new RegExp(`XSRF-TOKEN=([^;]+)`));
if (CSRF_TOKEN_GROUP != null) {
    CSRF_TOKEN = CSRF_TOKEN_GROUP[1];
}

@Component({
    components: {},
})
export default class CompositionUpload extends Vue {
    public loading = false;

    public error = false;
    public errorText = "";

    public infoText = "";

    public files = new Map<string, any>();

    public items = [];
    public headers = [
        {
            text: 'Name',
            sortable: true,
            value: 'name',
        },
        {
            text: 'Status',
            sortable: false,
            value: 'status',
        },
    ];

    public pagination = {
        page: 1,
        rowsPerPage: 100,
        totalItems: 0,
        totalPages: 0,

        rowsPerPageItems: [10, 20, 50, 100,],
    };

    public options = {
        url: '/import',
        paramName: 'uploadfile',
        headers: {"X-XSRF-TOKEN": CSRF_TOKEN}
    };

    onTotalProgress(progress: any, totalBytes: any, bytesSent: any) {
        this.infoText = "loading " + progress + "% (" + bytesSent + "/" + totalBytes + ")";
    }

    onUploadComplete(file: any, status: any, xhr: any) {
        // remove files from queue
        this.files.delete(file.name + "/" + file.size);

        this.infoText = "";

        if (status == "error") {
            this.error = true;
            this.errorText = "Error during loading " + file.name + " (" + file.size + " b)"
        }

        this.loading = false;

        // update queue
        this.loadData();
    }

    onAddedFile(file: any) {
        // starting loading
        this.loading = true;

        // add files into queue
        this.files.set(file.name + "/" + file.size, file);
    }

    @Watch('pagination', {deep: true})
    public onPaginationHandler(val: any, oldVal: any) {
        if (val.page !== oldVal.page || val.rowsPerPage !== oldVal.rowsPerPage) {
            this.loadData();
        }
    }

    private async loadData() {
        if (this.loading) {
            return;
        }

        this.loading = true;

        try {
            const response = await axios.get('/importFiles');
            this.items = await response.data._embedded.importFiles;
        } catch (e) {
            console.log(JSON.stringify(e));

            this.error = true;
            this.errorText = e.message + ', ' + e.config.url;
        }

        this.loading = false;
    }

    private async processFiles() {
        this.loading = true;

        try {
            const response = await axios.get('/process');

            this.loading = false;
            this.loadData();
        } catch (e) {
            console.log(JSON.stringify(e));

            this.error = true;
            this.errorText = e.message + ', ' + e.config.url;
        }

        this.loading = false;
    }

    private async created() {
        // update queue
        await this.loadData()

        // update queue periodically
        setInterval(this.loadData, 10000);
    }
}
